import _ from 'lodash';
import * as types from './action-types';
import * as devToolsTypes from '../../../redux/dev-tools/action-types';

const defaultState = {
    hasError: false,
    error: null,
    form: {},
    code: '',
    applying: false,
    vendorConfig: {},
    checkMaintenanceModePending: false
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
    case types.APPLY_PENDING:
        return Object.assign({}, state, {
            hasError: false,
            error: null,
            code: '',
            applying: true
        });
    case types.APPLY_FAILURE:
        return Object.assign({}, state, {
            hasError: true,
            error: action.error,
            code: action.error.code,
            applying: false
        });
    case types.APPLY_SUCCESS: {
        return Object.assign({}, state, {
            hasError: false,
            error: null,
            code: action.res.code,
            applying: false,
        });
    }
    case types.VENDOR_CONFIG_PENDING:
        return Object.assign({}, state, {
            hasError: false,
            error: null,
            vendorConfig: {},
            checkMaintenanceModePending: true
        });
    case types.VENDOR_CONFIG_FAILURE:
        return Object.assign({}, state, {
            hasError: false,
            error: action.error,
            vendorConfig: {},
            checkMaintenanceModePending: false
        });
    case types.VENDOR_CONFIG_SUCCESS:
        return Object.assign({}, state, {
            hasError: false,
            error: null,
            vendorConfig: action.res,
            checkMaintenanceModePending: false
        });
    case types.CLEAR_APPLICATION:
        return Object.assign({}, state, defaultState);
    case devToolsTypes.DEVTOOLS_FILLFORM:
        return Object.assign({}, state, { form: action.data, applying: false });
    default:
        return Object.assign({}, state);
    }
};

export default reducer;
